import { Link } from "react-router-dom";
import { ArrowRight, Linkedin } from "lucide-react";
import accionLogo from "@/assets/accion-logo-footer.webp";

const CALENDLY_URL = "https://calendly.com/cjudd-acciongroup/30min";

const Footer = () => {
  return (
    <footer className="theme-reset relative bg-primary text-primary-foreground">
      <div
        aria-hidden="true"
        className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-accent/60 to-transparent"
      />
      <div className="container mx-auto px-4 py-8 lg:py-10 lg:px-8">
        <div className="grid gap-10 md:grid-cols-3 md:items-start">
          {/* Brand */}
          <div className="flex flex-col gap-3">
            <img loading="lazy" decoding="async" src={accionLogo} alt="Accion Group" className="h-12 w-12 object-contain rounded self-start" />
            <h3 className="font-display font-semibold text-sm text-primary-foreground">
              About Accion Group
            </h3>
            <p className="text-[13px] leading-relaxed text-primary-foreground/70 max-w-sm text-pretty hyphens-auto">
              Accion Group is an advisory and technology company serving the utility sector. We are best known for independent regulatory oversight and our energy procurement software PowerPro.
            </p>
          </div>

          {/* Links */}
          <nav className="flex flex-col gap-4">
            <h3 className="font-display font-semibold text-xs uppercase tracking-[0.15em] text-primary-foreground/80">
              Navigate
            </h3>
            <ul className="flex flex-col gap-3">
              <li><Link to="/" className="text-sm text-primary-foreground/70 hover:text-accent hover:translate-x-0.5 inline-block transition-all duration-300">Home</Link></li>
              <li><Link to="/products/powerpro" className="text-sm text-primary-foreground/70 hover:text-accent hover:translate-x-0.5 inline-block transition-all duration-300">PowerPro</Link></li>
              <li><Link to="/products/utilityfiling" className="text-sm text-primary-foreground/70 hover:text-accent hover:translate-x-0.5 inline-block transition-all duration-300">UtilityFiling</Link></li>
              
              <li><Link to="/services/independent-monitor" className="text-sm text-primary-foreground/70 hover:text-accent hover:translate-x-0.5 inline-block transition-all duration-300">Independent Monitor</Link></li>
              <li><Link to="/about" className="text-sm text-primary-foreground/70 hover:text-accent hover:translate-x-0.5 inline-block transition-all duration-300">About</Link></li>
              <li><Link to="/careers" className="text-sm text-primary-foreground/70 hover:text-accent hover:translate-x-0.5 inline-block transition-all duration-300">Careers</Link></li>
            </ul>
          </nav>

          {/* CTA */}
          <div className="flex flex-col gap-4">
            <h3 className="font-display font-semibold text-xs uppercase tracking-[0.15em] text-primary-foreground/80">
              Get Started
            </h3>
            <Link
              to="/contact"
              className="group inline-flex items-center gap-1.5 text-sm text-primary-foreground hover:text-accent font-semibold transition-colors self-start"
            >
              Get In Touch
              <ArrowRight className="h-4 w-4 transition-transform duration-300 ease-out group-hover:translate-x-1" />
            </Link>
            <p className="text-sm leading-relaxed text-primary-foreground/70 max-w-xs">
              See how Accion can transform your procurement or regulatory process.
            </p>
            <a
              href="https://www.linkedin.com/company/accion-group/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Accion Group on LinkedIn"
              className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-primary-foreground/20 bg-primary-foreground/5 text-primary-foreground/70 hover:text-accent hover:border-accent/40 hover:bg-primary-foreground/10 transition-colors"
            >
              <Linkedin className="h-4 w-4" />
            </a>
          </div>
        </div>

        <div className="mt-8 pt-5 border-t border-primary-foreground/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-primary-foreground/80">
            © {new Date().getFullYear()} Accion Group. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link
              to="/terms-of-use"
              className="text-xs text-primary-foreground/80 hover:text-accent transition-colors"
            >
              Terms of Use
            </Link>
            <a
              href="https://pro.accionpower.com/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-primary-foreground/80 hover:text-accent transition-colors"
            >
              Privacy Policy
            </a>
            <a
              href="https://status.acciongroup.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-primary-foreground/80 hover:text-accent transition-colors"
            >
              App Status
            </a>
            <Link
              to="/security"
              className="text-xs text-primary-foreground/80 hover:text-accent transition-colors"
            >
              SOC 2 Type II Certified
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
